// extracted by mini-css-extract-plugin
export default {"container":"DoctorCard_container__E4BII","isPreferred":"DoctorCard_isPreferred__s5L1p","selectButton":"DoctorCard_selectButton__ylMC7"};